module.exports = __webpack_public_path__ + "img/rx-icon-6.37f9b680.png";